/**
 * Enum for available options for financial price types.
 *
 * -- IMPORTANT --
 *
 * These are values used for ado in java for the financial price type num, they can't be
 * changed here without breaking either the java enum or ado.
 * Use this strictly as a value that will be saved, the display value for this should be handled by
 * using this as a translation id.
 */
export enum FinancialFeeType {
  FREE = 'free',
  TIPPING_FEE = 'tipping fee',
  COST = 'cost',
}
